import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import AdminOvertimeService from './AdminOvertimeService';

const useManageAdminOvertimes = () => {
  const [overtimes, setOvertimes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const refreshOvertimes = async (params = {}) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await AdminOvertimeService.getAdminOvertimes(params);
      setOvertimes(response.data);
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to load overtime records';
      setError(errorMessage);
      toast.error(errorMessage);
      setOvertimes([]);
    } finally {
      setIsLoading(false);
    }
  };

  const addOvertime = async (overtimeData) => {
    try {
      const response = await AdminOvertimeService.addAdminOvertime(overtimeData);
      toast.success('Overtime record added successfully');
      await refreshOvertimes();
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to add overtime record';
      toast.error(errorMessage);
      throw err;
    }
  };

  const editOvertime = async (id, overtimeData) => {
    try {
      const response = await AdminOvertimeService.editAdminOvertime(id, overtimeData);
      toast.success('Overtime record updated successfully');
      await refreshOvertimes();
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to update overtime record';
      toast.error(errorMessage);
      throw err;
    }
  };

  const deleteOvertime = async (id) => {
    try {
      await AdminOvertimeService.deleteAdminOvertime(id);
      toast.success('Overtime record deleted successfully');
      await refreshOvertimes();
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to delete overtime record';
      toast.error(errorMessage);
      throw err;
    }
  };

  return {
    overtimes,
    isLoading,
    error,
    refreshOvertimes,
    addOvertime,
    editOvertime,
    deleteOvertime
  };
};

export default useManageAdminOvertimes;

